module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoXDyYUROoFZAAAAMNJREFUWMPtl9ENhDAMQxOLGW5VZmBVlih/J92JtoljqXzQP1Bkv1KTgLfWbOWCLV4vwPZ/4/DPNxR7O71qMNNDr/juumLe00NWhDUvZSALkan/ARideVR0VDfNQBUia949AgaCMR9mIAPBmk9DGIGomJuZeWQYMa9itIlBKcbUQy2ahYVyZ8zsSAFU+kAZQNEJnz8LlB1OMg0j5lUIKHZegYDqsbMQUJ05CwGVOQvx/FnAfppT0zCTbgbiTs/fn9PVABf09KLWKin4DAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/peke.png
// module id = K7Qp
// module chunks = 1